import SearchPageHeader from './SearchPageHeader';
import SearchPageHeaderContainer from './SearchPageHeader.container';

export default SearchPageHeaderContainer(SearchPageHeader);
